import { trpc } from "@blis/trpc/react";

import { LoadingPage } from "@/components/LoadingPage";
import { Breadcrumb } from "@/components/ui/breadcrumbs";
import { Centered } from "@/components/ui/container";
import { Tab, TabPanel, Tabs, TabsList } from "@/components/ui/tabs";
import { Text } from "@/components/ui/text";
import { Section } from "../components/Section";
import { UserDetailForm } from "../components/users/UserDetailForm";
import { useTabSearch } from "../hooks";

export function EditUserPage(params: { id: number }) {
  const tabsProps = useTabSearch();

  const { data, isLoading, error } = trpc.admin.user.get.useQuery({
    id: Number(params.id),
  });

  if (isLoading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <Centered>
        <Text isDanger>{error.message}</Text>
      </Centered>
    );
  }
  const user = data;

  if (!user) {
    return (
      <Centered>
        <Text>User not found</Text>
      </Centered>
    );
  }

  return (
    <>
      <Section.Title
        breadcrumb={
          <>
            <Breadcrumb href={{ to: "/admin/users" }}>Users</Breadcrumb>
            <Breadcrumb>{user.email}</Breadcrumb>
          </>
        }
      >
        {user.email}
      </Section.Title>
      <Tabs {...tabsProps}>
        <TabsList className="w-full justify-start">
          <Tab id="details">Details</Tab>
        </TabsList>
        <TabPanel id="details">
          <UserDetailForm user={user} />
        </TabPanel>
      </Tabs>
    </>
  );
}
